module.exports = __webpack_public_path__ + "img/elonmusk.eb467884.jpg";